import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useBrand } from "@/context/BrandContext";
import {
  LayoutDashboard,
  Carrot,
  ChefHat,
  Tags,
  FileText,
  LogOut,
  ChevronRight,
  Settings as SettingsIcon,
} from "lucide-react";
import { Button } from "@/components/ui/button";

const nav = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true, id: "dashboard" },
  { to: "/ingredienti", label: "Ingredienti", icon: Carrot, id: "ingredienti" },
  { to: "/ricette", label: "Ricette", icon: ChefHat, id: "ricette" },
  { to: "/etichette", label: "Etichette", icon: Tags, id: "etichette" },
  { to: "/fatture", label: "Fatture XML", icon: FileText, id: "fatture" },
  { to: "/impostazioni", label: "Impostazioni", icon: SettingsIcon, id: "impostazioni" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const { brand } = useBrand();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <aside className="w-64 shrink-0 border-r border-border bg-card flex flex-col fixed h-screen">
        <div className="px-6 py-6 border-b border-border">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center overflow-hidden shrink-0">
              {brand.logo ? (
                <img src={brand.logo} alt="logo" className="w-full h-full object-contain" data-testid="sidebar-logo" />
              ) : (
                <ChefHat className="w-5 h-5 text-primary-foreground" />
              )}
            </div>
            <div className="min-w-0">
              <h1 className="font-display font-extrabold text-lg leading-none tracking-tight truncate">{brand.business_name}</h1>
              <p className="text-xs text-muted-foreground mt-0.5">Controllo gestione</p>
            </div>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`nav-${item.id}`}
              className={({ isActive }) =>
                `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary text-primary-foreground"
                    : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                }`
              }
            >
              <item.icon className="w-[18px] h-[18px]" />
              {item.label}
              <ChevronRight className="w-4 h-4 ml-auto opacity-0 group-hover:opacity-60 transition-opacity" />
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-border">
          <div className="px-3 py-2 mb-1">
            <p className="text-sm font-medium truncate">{user?.name}</p>
            <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
          </div>
          <Button
            variant="ghost"
            className="w-full justify-start gap-3 text-muted-foreground hover:text-destructive"
            onClick={handleLogout}
            data-testid="logout-btn"
          >
            <LogOut className="w-[18px] h-[18px]" />
            Esci
          </Button>
        </div>
      </aside>

      <main className="flex-1 ml-64 min-h-screen">
        <div className="max-w-7xl mx-auto px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
